module.exports = __webpack_public_path__ + "static/media/artigo-espiritismo.74fb283c.md";